import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../state/AuthContext";
import { logoutUser } from "../../services/UserService.ts";

function OffcanvasMenu({ open, onClose }) {
  const location = useLocation();
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return undefined;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const handleLogout = async () => {
    try {
      await logoutUser();
      logout();
      onClose();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <>
      <div
        className={`offcanvas-backdrop ${open ? "is-visible" : ""}`}
        onClick={onClose}
        aria-hidden="true"
      />

      <aside
        className={`offcanvas-menu ${open ? "is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-hidden={!open}
        aria-label="Navigation menu"
      >
        <div className="offcanvas-menu-header">
          <h3 className="offcanvas-menu-title">Menu</h3>
          <button
            type="button"
            className="navbar-icon offcanvas-close"
            aria-label="Close menu"
            onClick={onClose}
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <nav className="offcanvas-menu-nav" aria-label="Mobile navigation">
          <p className="offcanvas-menu-group-label">Learn</p>
          <ul className="offcanvas-menu-list">
            <li>
              <Link
                to="/basic"
                className={`offcanvas-menu-link ${isActive("/basic") ? "active" : ""}`}
                onClick={onClose}
              >
                Basic Content
              </Link>
            </li>
            <li>
              <Link
                to="/advanced"
                className={`offcanvas-menu-link ${isActive("/advanced") ? "active" : ""}`}
                onClick={onClose}
              >
                Advanced Content
              </Link>
            </li>
          </ul>

          <ul className="offcanvas-menu-list offcanvas-menu-secondary">
            <li>
              <a
                href="https://d-smart.cls.chalmers.se/chat/"
                className="offcanvas-menu-link"
                onClick={onClose}
              >
                Digital Tools
              </a>
            </li>
            <li>
              <Link to="/" className="offcanvas-menu-link" onClick={onClose}>
                Publications
              </Link>
            </li>
            <li>
              <Link to="/" className="offcanvas-menu-link" onClick={onClose}>
                About Us
              </Link>
            </li>
          </ul>

          <ul className="offcanvas-menu-list offcanvas-menu-tertiary">
            {isLoggedIn ? (
              <>
                <li>
                  <Link
                    to="/profile"
                    className={`offcanvas-menu-link ${isActive("/profile") ? "active" : ""}`}
                    onClick={onClose}
                  >
                    Profile
                  </Link>
                </li>
                <li>
                  <button
                    type="button"
                    className="offcanvas-menu-link"
                    onClick={handleLogout}
                  >
                    Log Out
                  </button>
                </li>
              </>
            ) : (
              <li>
                <Link
                  to="/login"
                  className={`offcanvas-menu-link ${isActive("/login") ? "active" : ""}`}
                  onClick={onClose}
                >
                  Sign In
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </aside>
    </>
  );
}

export default OffcanvasMenu;
